import { PRIVATE_SALE_CONTRACT_ADDRESS } from '@wolffun/shared/constants';
import { getCurrentConnector, walletClient } from '@wolffun/shared/src/utils/walletClient';
const address = PRIVATE_SALE_CONTRACT_ADDRESS;
const symbol = 'THG';
const decimals = 18;
const abi = [{
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'address',
    name: 'user',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'busdAmount',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'thcAmount',
    type: 'uint256'
  }],
  name: 'BuyPrivateSale',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'previousOwner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'OwnershipTransferred',
  type: 'event'
}, {
  inputs: [],
  name: 'busdReceiverAddress',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'busdToken',
  outputs: [{
    internalType: 'contract IERC20',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'busdAmount',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'thcAmount',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'signature',
    type: 'bytes'
  }],
  name: 'buyPrivateSale',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'user',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'busdAmount',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'thcAmount',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'expiredAt',
    type: 'uint256'
  }],
  name: 'getBuyPrivateSaleMessageHash',
  outputs: [{
    internalType: 'bytes32',
    name: '',
    type: 'bytes32'
  }],
  stateMutability: 'pure',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  name: 'ids',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'owner',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'renounceOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'receiver',
    type: 'address'
  }],
  name: 'setBusdReceiverAddress',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'token',
    type: 'address'
  }],
  name: 'setBusdToken',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }],
  name: 'setSigner',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'receiver',
    type: 'address'
  }],
  name: 'setThcReceiverAddress',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'token',
    type: 'address'
  }],
  name: 'setThcToken',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'signer',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'thcReceiverAddress',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'thcToken',
  outputs: [{
    internalType: 'contract IERC20',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'transferOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'busdAmount',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'thcAmount',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'signature',
    type: 'bytes'
  }],
  name: 'verifyBuyPrivateSaleSignature',
  outputs: [],
  stateMutability: 'view',
  type: 'function'
}];

const getContract = () => {
  if (walletClient) {
    return getCurrentConnector().getContract({
      address,
      contractInterface: abi
    });
  }

  return undefined;
};

export default {
  address,
  symbol,
  decimals,
  abi,
  getContract
};